// ModalContext.ts
import { createContext } from 'react';

export type ModalVariant = 'neutral' | 'warning';

export const ModalVariantContext = createContext<ModalVariant>('neutral');